module.exports = __webpack_public_path__ + "static/media/img_16.1408f2cc.png";